import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Cover from '../views/Cover.vue'
import PageNotFound from '../views/404.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: '/:slug',
    name: 'Home',
    component: Home
  },
  {
    path: '/cover/:slug',
    name: 'Cover',
    component: Cover
  },
  {
    path: '*',
    redirect: { name: 'PageNotFound' }
  },
  {
      path: '/not-found',
      name: 'PageNotFound',
      component: PageNotFound
  }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
